export const layers = (zoom) => [
    {
        "id": "place",
        "type": "symbol",
        "source": "baselayer",
        "source-layer": "waypoint",
        "layout": {
            "text-field": "{name}",
            "text-offset": [0, -1],
            "text-anchor": "bottom",
            'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
            "text-font": ['case', ["<=",["get", "order"], 1],
                ['literal',["BarlowCondensed-SemiBold",]],
                ['literal',["BarlowCondensed-Regular",]]
            ],
            "text-size": [
                'step', ['get', 'order'],
                18 * zoom,
                2, 17 * zoom,
                3, 16 * zoom,
                4, 14 * zoom,
            ],
        },
        "paint": {
            "text-color": "#111",
            "text-halo-color": "#fff",
            "text-halo-width": 2
        },
    },
    {
        "id": "icon-low-zoom",
        "type": "symbol",
        "source": "baselayer",
        "source-layer": "waypoint",
        "minzoom": 15,
        "layout": {
            "text-field": "{icons}",
            "text-font": ["icons",],
            "text-size": 20 * zoom,
            "text-letter-spacing": 0.1,
            "text-allow-overlap": true,
            'text-variable-anchor': ["top", "center", "left", "right", "top", 
                "bottom", "top-left", "top-right", "bottom-left", "bottom-right"],
            "text-max-width" : 3,
        },
        "paint": {
            "text-color": "#294B62",
            "text-halo-color": "#fff",
            "text-halo-width": 2,
        },
    },
    {
        "id": "icon",
        "type": "symbol",
        "source": "baselayer",
        "source-layer": "waypoint",
        "minzoom": 13,
        "maxzoom": 15,
        "layout": {
            "text-field": "{icons}",
            "text-font": ["icons",],
            "text-size": 20 * zoom,
            "text-letter-spacing": 0.1,
            "text-allow-overlap": false,
            'text-variable-anchor': ["top", "center", "left", "right", "top", 
                "bottom", "top-left", "top-right", "bottom-left", "bottom-right"],
            "text-max-width" : 3,
        },
        "paint": {
            "text-color": "#294B62",
            "text-halo-color": "#fff",
            "text-halo-width": 2,
        },
    }
]
